import { useSite } from "../context/SiteContentContext";
import { Clock } from "lucide-react";

export const Services = ({ onSelectService }) => {
    const siteConfig = useSite();
    return (
        <section
            id="services"
            data-testid="services-section"
            className="relative py-24 md:py-32 px-6 md:px-12 bg-[#0a0a0a] border-t border-[#262626]"
        >
            <div className="max-w-7xl mx-auto">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 mb-16 md:mb-24">
                    <div className="lg:col-span-5">
                        <div className="ornamental-divider mb-6">
                            <span>A Carta</span>
                        </div>
                        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-none text-[#f5f5f0]">
                            Serviços
                            <br />
                            <span className="italic font-normal text-[#a3a3a3]">
                                e preços.
                            </span>
                        </h2>
                    </div>
                    <div className="lg:col-span-6 lg:col-start-7 flex items-end">
                        <p className="font-body text-base md:text-lg text-[#a3a3a3] leading-relaxed">
                            Sem ginásticas, sem surpresas. Preços directos e
                            tempos realistas para te cortarem o cabelo como
                            deve ser. Carrega num serviço para iniciares a
                            reserva.
                        </p>
                    </div>
                </div>

                <div className="border-t border-[#262626]">
                    {siteConfig.services.map((service, idx) => (
                        <button
                            key={service.id}
                            onClick={() => onSelectService(service)}
                            data-testid={`service-row-${service.id}`}
                            className="service-row w-full text-left flex flex-col md:flex-row md:items-baseline gap-2 md:gap-0 py-8 md:py-10 border-b border-[#262626] group"
                        >
                            <div className="flex-1">
                                <div className="flex items-baseline gap-4 mb-2">
                                    <span className="font-display text-xs text-[#737373] tabular-nums">
                                        {String(idx + 1).padStart(2, "0")}
                                    </span>
                                    <h3 className="font-display text-2xl md:text-4xl font-semibold text-[#f5f5f0] group-hover:text-[#d4af37] transition-colors duration-300">
                                        {service.name}
                                    </h3>
                                </div>
                                <div className="flex items-center gap-3 pl-10 text-[#737373]">
                                    <Clock size={13} />
                                    <span className="text-xs tracking-wider uppercase">
                                        {service.duration} min
                                    </span>
                                    <span className="text-[#404040]">·</span>
                                    <span className="text-sm text-[#a3a3a3]">
                                        {service.description}
                                    </span>
                                </div>
                            </div>

                            <div className="hidden md:block leader" />

                            <div className="flex items-baseline gap-1 pl-10 md:pl-0">
                                <span className="font-display text-3xl md:text-4xl font-bold text-[#d4af37] tabular-nums">
                                    {service.price}
                                </span>
                                <span className="font-display text-xl text-[#d4af37]">
                                    €
                                </span>
                            </div>
                        </button>
                    ))}
                </div>

                <div className="mt-16 flex justify-center">
                    <p className="text-xs tracking-widest uppercase text-[#737373]">
                        Pagamento no local · Dinheiro · MB Way
                    </p>
                </div>
            </div>
        </section>
    );
};
